<template>
  <div class="header">
    <div class="wrapper">
      <a-row :gutter="16" type="flex">
        <a-col>
          <span class="t-label">Filtruj:</span>
        </a-col>
        <a-col class="filters-col">
          <a-row type="flex" class="ant-row-flex-multiline" :gutter="16">
            <a-col>
              <a-range-picker
                :value="rangePickerValue"
                class="c-ghost-input"
                @change="onRangeChange"
              />
            </a-col>
            <a-col>
              <a-select
                class="c-ghost-input"
                showSearch
                v-model="status"
                :options="statuses"
                allowClear
                placeholder="Status zajęć"
                optionFilterProp="children"
                style="width: 176px"
              />
            </a-col>
          </a-row>
        </a-col>
      </a-row>

      <div></div>
    </div>
  </div>
</template>

<script>
import ListHeader from '@/components/layout/ListHeader'
import moment from 'moment'

export default {
  queryModels: ['search', 'status', 'timespan_after', 'timespan_before'],
  extends: ListHeader,
  methods: {
    onRangeChange(value) {
      const after = value[0] && this.getDateOnly(value[0])
      const before = value[1] && this.getDateOnly(value[1])
      this.timespan_after = after
      this.timespan_before = before
    }
  },
  computed: {
    rangePickerValue() {
      const start = this.timespan_after && moment(this.timespan_after)
      const end = this.timespan_before && moment(this.timespan_before)
      return [start, end]
    },
    statuses() {
      return [
        { value: 'cancelled', label: 'Odwołane' },
        { value: 'has_taken_place', label: 'Odbyły się' },
        { value: 'has_not_taken_place', label: 'Nie odbyły się' }
      ]
    }
  }
}
</script>
